
const NavBarWrapper = ({ user, children }) => {
  return (
    (user.isLogged) &&
    children
  );
};

export default NavBarWrapper;
